import LinkPreviewOptionState from '../store/schema/LinkPreviewOptionState';
import store from '../store/store';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import HelpLink from './HelpLink';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { getFallbackValueIfNull } from 'owa-options-core';
import selectLinkPreviewIsEnabledOption from '../actions/selectLinkPreviewIsEnabledOption';

export interface LinkPreviewFullProps {
    optionStore?: LinkPreviewOptionState;
    userOptions?: UserOptionsType;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class LinkPreviewFull extends React.Component<LinkPreviewFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        let isEnabled = getFallbackValueIfNull(
            optionStore.isEnabled,
            userOptions.LinkPreviewEnabled
        );

        return (
            <div>
                <OptionDescription>
                    {strings.options_mail_linkPreviewDescription}
                    &nbsp;
                    <HelpLink helpId="LinkPreview" />
                </OptionDescription>
                <OptionsCheckbox
                    checked={isEnabled}
                    label={strings.options_mail_linkPreviewCheckboxLabel}
                    onChange={this.toggleEnable}
                />
            </div>
        );
    }

    private toggleEnable(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        selectLinkPreviewIsEnabledOption(checked);
    }
}
